export default {
  labels: {
    open: 'Artikelen tonen',
    collapse: 'Artikelen sluiten',
    in_stock: 'Op voorraad',
    out_of_stock: 'Niet op voorraad',
    visible: 'Zichtbaar in menu',
    hidden: 'Verborgen uit menu',
  },
  list: {
    name: 'Menu-item',
    price: 'Prijs',
    is_available: 'OP/NIET OP VOORRAAD',
  },
};
